import React from "react";
import { useLocation } from "react-router-dom";
import CookiePolicy from "./CookiePolicy";
import RefundPolicy from "./RefundPolicy";
import {
  TermsAndConditions,
  PrivacyPolicy,
  CollaborationPolicy,
  CommunityGuidelines,
  CollaborationAgreement,
} from "./terms-and-condition";

interface PoliciesProps {
  component?: string;
}

const Policies: React.FC<PoliciesProps> = ({ component }) => {
  const location = useLocation();

  // Use the passed prop or fallback to location.state
  const stateComponent =
    component || (location.state as { component?: string })?.component;

  switch (stateComponent) {
    case "TermsAndConditions":
      return <TermsAndConditions />;
    case "PrivacyPolicy":
      return <PrivacyPolicy />;
    case "CollaborationPolicy":
      return <CollaborationPolicy />;
    case "CollaborationAgreement":
      return <CollaborationAgreement />;
    case "CookiePolicy":
      return <CookiePolicy />;
    case "RefundPolicy":
      return <RefundPolicy />;
    default:
      return <CommunityGuidelines />;
  }
};

export default Policies;
